// import jquery from 'jquery';
//import './extern/lib'
import wwdev from '@wwdev/functions';
import * as bootstrap from 'bootstrap';

//window.jquery = jQuery;
window.wwdev = wwdev;
window.bootstrap = bootstrap;

$.ajaxSetup({
	headers: {
		'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	}
});
